import React from "react"
import { Helmet } from "react-helmet"
import { graphql, StaticQuery } from "gatsby"
import csufIcon from "../assets/images/favicon.ico"
import socialBanner from "../assets/images/social-media-image.jpg";


const SiteMetadata = ({ pathname }) => (
  <StaticQuery
    query={graphql`
      query SiteMetadata {
        site {
          siteMetadata {
            siteUrl
            title
            description
          }
        }
      }
    `}
    render={({
      site: {
        siteMetadata: { siteUrl, title, description },
      },
    }) => (
      <Helmet defaultTitle={title} titleTemplate={`%s | ${title}`}>
        <html lang="en" />
        <link rel="canonical" href={`${siteUrl}${pathname}`} />
        <meta name="viewport" content="width=device-width,initial-scale=1,shrink-to-fit=no,viewport-fit=cover" />
        <meta property="og:url" content={siteUrl} />
        <meta property="og:type" content="website" />
        <meta property="og:locale" content="en" />
        <meta property="og:site_name" content={title} />
        <meta name="description" content={description} />
        <link rel="icon" href={csufIcon} />

        {/* Schema.org markup for Google+ */}
        <meta itemprop="name" content={title} />
        <meta itemprop="description" content={description} />
        <meta itemprop="image" content={socialBanner} />

        {/* Twitter Card data */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@csuf" />
        <meta name="twitter:title" content={title} />
        <meta name="twitter:description" content={description} />
        {/* <meta name="twitter:creator" content="@author_handle"> */}
        {/* Twitter summary card with large image must be at least 280x150px */}
        <meta name="twitter:image:src" content={socialBanner} />

        {/* Open Graph data */}
        <meta property="og:title" content={title} />
        <meta property="og:type" content="article" />
        <meta property="og:url" content={siteUrl} />
        <meta property="og:image" content={socialBanner} />
        <meta property="og:description" content={description} />
        <meta property="og:site_name" content="CSUF News Center" />
      </Helmet>
    )}
  />
)

export default SiteMetadata